// extracted by mini-css-extract-plugin
export var container = "_or-0";